import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { DefaultDialogTitle } from '../../../components/styled/Dialog'
import SelectionTable from '../../../components/datatable/SelectionTable'
import Input from '../../../components/forms/Input'
import { searchAllCharacters } from '../../../utils/StringUtil'

const IndicatorsObjectsDialog = ({
    open = false,
    label = '',
    objects = [],
    selectedCodes = [],
    onClose = () => {},
    onValidate = () => {},
}) => {
    const [codes, setCodes] = useState(selectedCodes)
    const [searchValue, setSearchValue] = useState('')

    useEffect(() => {
        if (open) {
            setCodes(selectedCodes)
            setSearchValue('')
        }
    }, [open])

    const rows = useMemo(() => objects.map(({ code, name }) => ({ code, name: name || '' })), [objects])

    const [selectedRows, listRows] = useMemo(() => {
        const searched = searchAllCharacters(searchValue)
        const filtered = searchValue ? rows.filter(row => searchAllCharacters(`${row.code}${row.name}`).includes(searched)) : rows
        return [
            rows.filter(row => codes.includes(row.code)),
            filtered.filter(row => !codes.includes(row.code)),
        ]
    }, [rows, codes, searchValue])

    return (
        <Dialog open={open} maxWidth='lg' fullWidth>
            <DefaultDialogTitle title={label} onClose={onClose} />
            <DialogContent>
                <div style={{ minHeight: '65vh' }}>
                    <Grid container sx={{ pt: '10px', pb: '20px' }}>
                        <Grid size={6}>
                            <Input
                                title={i18n.search}
                                value={searchValue}
                                onChange={setSearchValue}
                            />
                        </Grid>
                    </Grid>
                    <SelectionTable
                        maxHeight='38vh'

                        listData={listRows}
                        listHeaders={['code', 'name']}
                        listCustomHeaders={{ code: i18n.code, name: i18n.name }}
                        listTitle={label}

                        selectedData={selectedRows}
                        selectedHeaders={['code', 'name']}
                        selectedCustomHeaders={{ code: i18n.code, name: i18n.name }}
                        selectedTitle={i18n.selection}

                        onAdd={row => setCodes(prev => [...prev, row.code])}
                        addAll={addedRows => setCodes(prev => [...prev, ...addedRows.map(row => row.code)])}
                        onDelete={row => setCodes(prev => prev.filter(code => code !== row.code))}
                        deleteAll={() => setCodes([])}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color='primary' onClick={() => onValidate(codes)}>
                    {i18n.save}
                </Button>
                <Button variant='outlined' onClick={onClose}>
                    {i18n.close}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

IndicatorsObjectsDialog.propTypes = {
    open: PropTypes.bool,
    label: PropTypes.string,
    objects: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
        name: PropTypes.string,
    })),
    selectedCodes: PropTypes.arrayOf(PropTypes.string),
    onClose: PropTypes.func,
    onValidate: PropTypes.func,
}

export default IndicatorsObjectsDialog